import { Component, Input, OnInit } from '@angular/core';
import twttr from 'twitter-text';

import { SiteTypeEnum } from '../../enums';
import { Site } from '../../models/misc.model';

@Component({
  selector: 'app-message-text-content',
  templateUrl: './message-text-content.component.html',
  styleUrls: ['./message-text-content.component.scss'],
})
export class MessageTextContentComponent implements OnInit {
  @Input() content: string;
  @Input() site: Site;
  @Input() isPrivate: boolean;

  entities: any[]; // mixes entities returned by twitter-text and text entities

  constructor() {}

  ngOnInit() {
    if (this.content) {
      this.initUrlsHashesAndMentions();
    }
  }

  onLinkClicked(event) {
    // from the task list, clicking a link musn't trigger processing the message
    event.stopPropagation();
  }

  private initUrlsHashesAndMentions() {
    let entities = twttr.extractUrlsWithIndices(this.content);
    if (this.site.type === SiteTypeEnum.Twitter && !this.isPrivate) {
      entities = entities
        .concat(twttr.extractMentionsOrListsWithIndices(this.content))
        .concat(twttr.extractHashtagsWithIndices(this.content, { checkUrlOverlap: false }));
    }
    if (entities.length > 1) {
      twttr.removeOverlappingEntities(entities);
    }
    this.updateEntities(entities);
  }

  private updateEntities(entities) {
    this.entities = [];
    let lastEndPosition = 0;

    for (const entity of entities) {
      // Text before the url
      const text = this.content.slice(lastEndPosition, entity.indices[0]);
      if (text.length > 0) {
        this.entities.push({ text });
      }
      this.entities.push(entity);
      lastEndPosition = entity.indices[1];
    }

    // last string at the end
    if (this.content.length > lastEndPosition) {
      const text = this.content.slice(lastEndPosition, this.content.length);
      if (text.length > 0) {
        this.entities.push({ text });
      }
    }
  }
}
